import { _ } from "../../../polyglot/polyglot.js";
import { notBlank } from "../../../widgets/forms/validators.js";
import AbstractFormStep from "../../AbstractFormStep.js";

/**
 * Wizard step asking the user to enter a username and a password that will
 * be used for authentication.
 */
export default class UsernamePasswordLoginStep extends AbstractFormStep {
	_populateForm(form) {
		this._usernameInput = form.input({
			label: _("Username"),
			name: "username",
			attribute: "credentials.username",
			validator: notBlank(),
		});

		this._passwordInput = form.input({
			type: "password",
			name: "password",
			label: _("Password"),
			attribute: "credentials.password",
			validator: notBlank(),
		});

		this._passwordInput.register("input", () => {
			this.completed.trigger();
		});

		this._usernameInput.register("input", () => {
			this.completed.trigger();
		});
	}
}
